// extracted by mini-css-extract-plugin
export default {"container_images":"ImageDataCard_container_images__Glayk","title":"ImageDataCard_title__+LomL","imageBox":"ImageDataCard_imageBox__Y4lw3"};